module.exports = __webpack_public_path__ + "static/media/pause.31b7654b.svg";